import { TFunction } from 'i18next';
import { CEILINGS_LANDING_NAME, CEILINGS_CDN_PATH } from '../../ceilings-constants';

export const getPhotoPrintingGalleryList = (t: TFunction) => [
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/14.jpg/14.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/14.jpg/14.jpg`,
    alt: t('photo-printing-section.title'),
    name: '14.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/6.jpg/6.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/6.jpg/6.jpg`,
    alt: t('photo-printing-section.title'),
    name: '6.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/18.jpg/18.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/18.jpg/18.jpg`,
    alt: t('photo-printing-section.title'),
    name: '18.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/1.jpg/1.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/1.jpg/1.jpg`,
    alt: t('photo-printing-section.title'),
    name: '1.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/2.jpg/2.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/2.jpg/2.jpg`,
    alt: t('photo-printing-section.title'),
    name: '2.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/3.jpg/3.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/3.jpg/3.jpg`,
    alt: t('photo-printing-section.title'),
    name: '3.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/4.jpg/4.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/4.jpg/4.jpg`,
    alt: t('photo-printing-section.title'),
    name: '4.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/5.jpg/5.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/5.jpg/5.jpg`,
    alt: t('photo-printing-section.title'),
    name: '5.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/7.jpg/7.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/7.jpg/7.jpg`,
    alt: t('photo-printing-section.title'),
    name: '7.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/8.jpg/8.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/8.jpg/8.jpg`,
    alt: t('photo-printing-section.title'),
    name: '8.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/9.jpg/9.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/9.jpg/9.jpg`,
    alt: t('photo-printing-section.title'),
    name: '9.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/10.jpg/10.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/10.jpg/10.jpg`,
    alt: t('photo-printing-section.title'),
    name: '10.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/11.jpg/11.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/11.jpg/11.jpg`,
    alt: t('photo-printing-section.title'),
    name: '11.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/12.jpg/12.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/12.jpg/12.jpg`,
    alt: t('photo-printing-section.title'),
    name: '12.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/13.jpg/13.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/13.jpg/13.jpg`,
    alt: t('photo-printing-section.title'),
    name: '13.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/15.jpg/15.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/15.jpg/15.jpg`,
    alt: t('photo-printing-section.title'),
    name: '15.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/16.jpg/16.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/16.jpg/16.jpg`,
    alt: t('photo-printing-section.title'),
    name: '16.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/17.jpg/17.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/17.jpg/17.jpg`,
    alt: t('photo-printing-section.title'),
    name: '17.jpg',
  },
  {
    src: `${CEILINGS_LANDING_NAME}/photo-printing-popup/19.jpg/19.jpg`,
    srcThumb: `${CEILINGS_CDN_PATH}/photo-printing-popup-thumb/19.jpg/19.jpg`,
    alt: t('photo-printing-section.title'),
    name: '19.jpg',
  },
];
